module.exports = __webpack_public_path__ + "static/media/news-image-03.82a0a655.jpg";